/*
 *   File : summary-card.js
 *   Author : https://evoqins.com
 *   Description : summary card component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React from "react";
import Icon from "../icons";

export default function SummaryCard({
  title,
  description,
  value,
  icon,
  iconSize = 16,
  valueClassName = "text-medium-sea-green",
}) {
  return (
    <div className="e-glass-card e-drop-shadow-summary border border-white  p-3 rounded-16 d-flex flex-column rg-14">
      <h5 className="mb-0 fw-400 fs-14 lh-20 text-eerie-black">{title}</h5>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="fw-500 fs-22 lh-32 mb-0 text-eerie-black text-capitalize">
          {description}
        </h3>
        {(value || icon) && (
          <div className="d-flex column-gap-2 align-items-center">
            {value ? (
              <p className={`mb-0 fw-500 fs-12 lh-16 ${valueClassName}`}>
                {value}
              </p>
            ) : null}
            {icon ? <Icon icon={icon} size={iconSize} /> : null}
          </div>
        )}
      </div>
    </div>
  );
}
